var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6315 49.263C38.2351 49.263 49.263 38.2351 49.263 24.6315C49.263 11.0279 38.2351 0 24.6315 0C11.0279 0 0 11.0279 0 24.6315C0 38.2351 11.0279 49.263 24.6315 49.263Z",
    fill: "#55A47E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5477 28.1967L34.9085 15.2062C35.3064 14.893 35.788 14.7044 36.2928 14.6641C36.7975 14.6237 37.3029 14.7334 37.7455 14.9794C38.1881 15.2254 38.5482 15.5966 38.7805 16.0466C39.0127 16.4965 39.1069 17.0051 39.0511 17.5084C39.0134 17.8434 38.9099 18.1676 38.7464 18.4624C38.5829 18.7572 38.3627 19.0167 38.0984 19.226L19.5147 33.9775L19.3343 34.1218C19.2599 34.174 19.1828 34.2222 19.1034 34.2662L19.0023 34.3311C18.4157 34.6342 17.7346 34.699 17.1013 34.5121C16.468 34.3252 15.9313 33.901 15.6031 33.328L15.3145 32.8444L10.544 24.5521C10.3768 24.2612 10.2684 23.9401 10.2252 23.6073C10.182 23.2745 10.2048 22.9364 10.2923 22.6124C10.3797 22.2884 10.5301 21.9847 10.7349 21.7188C10.9397 21.453 11.1949 21.23 11.4859 21.0627C12.0735 20.7249 12.7712 20.6343 13.4256 20.811C13.7496 20.8984 14.0533 21.0488 14.3191 21.2536C14.585 21.4584 14.808 21.7136 14.9753 22.0045L18.5549 28.1967H18.5477Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlertIcon);
export default __webpack_public_path__ + "static/media/rightAlertIcon.e0386c08bb326377e9897884cec1eb30.svg";
export { ForwardRef as ReactComponent };